const COOKIE_STORAGE_KEY = "hiperbola_cookie_consent_v1";

function readStoredSettings() {
  try {
    const raw = localStorage.getItem(COOKIE_STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (typeof data !== "object" || data === null) return null;
    if (typeof data.all !== "boolean") return null;
    if (typeof data.ts !== "number") return null;
    return data;
  } catch (error) {
    return null;
  }
}

function writeStoredSettings(all) {
  const data = {
    all: Boolean(all),
    ts: Date.now(),
  };
  localStorage.setItem(COOKIE_STORAGE_KEY, JSON.stringify(data));
  return data;
}

function loadExternalMaps(root) {
  const maps = root.querySelectorAll(".cookie-map[data-src]");
  maps.forEach((container) => {
    if (container.dataset.loaded === "true") return;
    const iframe = document.createElement("iframe");
    iframe.src = container.dataset.src;
    iframe.title = container.dataset.title || "Map location";
    iframe.loading = "lazy";
    iframe.referrerPolicy = "strict-origin-when-cross-origin";
    iframe.allowFullscreen = true;
    container.innerHTML = "";
    container.appendChild(iframe);
    container.dataset.loaded = "true";
  });
}

function loadExternalReviews() {
  const sections = document.querySelectorAll(".cookie-reviews");
  if (!sections.length) return;
  sections.forEach((section) => {
    section.classList.add("cookie-reviews--loaded");
    const block = section.querySelector(".cookie-block");
    if (block) block.remove();
  });
  if (document.querySelector("#cookie-review-script")) return;
  const script = document.createElement("script");
  script.id = "cookie-review-script";
  script.src = "https://widgets.sociablekit.com/google-reviews/widget.js";
  script.defer = true;
  document.body.appendChild(script);
}

function loadExternalContent(root) {
  loadExternalMaps(root);
  loadExternalReviews();
}

class CookieBanner extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector("[data-cookie-panel]");
    this.primary = this.querySelector("[data-cookie-primary]");
    this.preferences = this.querySelector("[data-cookie-preferences]");
    this.externalInput = this.querySelector("[data-cookie-external]");
    this.closeButton = this.querySelector("[data-cookie-close]");
    this.settings = readStoredSettings();
    if (!this.panel) return;

    this.bindEvents();
    this.init();
  }

  bindEvents() {
    const on = (selector, fn) => {
      const el = this.querySelector(selector);
      if (el) el.addEventListener("click", fn.bind(this));
    };

    on("[data-cookie-accept]", this.acceptAll);
    on("[data-cookie-settings]", this.showSettings);
    on("[data-cookie-cancel]", this.showPrimary);
    on("[data-cookie-save]", this.saveChoice);

    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => this.hide());
    }

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-cookie-settings]");
      if (trigger && !this.contains(trigger)) {
        this.show();
        return;
      }
      const triggerLegacy = event.target.closest("[data-cookie-ustawienia]");
      if (triggerLegacy && !this.contains(triggerLegacy)) {
        this.show();
        return;
      }
      const accept = event.target.closest("[data-cookie-accept-external]");
      if (accept) this.acceptAll();
      const acceptLegacy = event.target.closest("[data-cookie-akceptuj-zewnetrzne]");
      if (acceptLegacy) this.acceptAll();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.settings && !this.hidden) {
        this.hide();
      }
    });
  }

  init() {
    if (this.settings) {
      this.hidden = true;
      if (this.settings.all) loadExternalContent(this);
    } else {
      this.show();
    }
  }

  show() {
    this.hidden = false;
    if (this.closeButton) {
      this.closeButton.classList.toggle("cookie-close--visible", Boolean(this.settings));
    }
    this.showPrimary();
  }

  hide() {
    this.hidden = true;
  }

  showPrimary() {
    if (this.primary) this.primary.hidden = false;
    if (this.preferences) this.preferences.hidden = true;
  }

  showSettings() {
    if (this.primary) this.primary.hidden = true;
    if (this.preferences) this.preferences.hidden = false;
    if (this.externalInput) {
      this.externalInput.checked = Boolean(this.settings && this.settings.all);
    }
  }

  acceptAll() {
    this.settings = writeStoredSettings(true);
    loadExternalContent(this);
    this.hide();
  }

  saveChoice() {
    const previous = Boolean(this.settings && this.settings.all);
    const now = Boolean(this.externalInput && this.externalInput.checked);
    this.settings = writeStoredSettings(now);
    if (now) {
      loadExternalContent(this);
      this.hide();
      return;
    }
    this.hide();
    if (previous) window.location.reload();
  }
}

if (!customElements.get("cookie-banner")) {
  customElements.define("cookie-banner", CookieBanner);
}
